import React from 'react'
import PropTypes from 'prop-types'
import IssueSummaryCard from './IssueSummaryCard'
import IssueFilesCard from './IssueFilesCard'
import IssueCommentCard from './IssueCommentCard'

const WRAPPER_CLASS = 'tw:flex tw:flex-col tw:gap-4'

const IssueSummaryTab = ({
  issue, issueStatuses, statusValue, onStatusChange,
  recipientOptions, selectedUsers, onUsersChange,
  isEditing, onEdit, commentValue, onCommentChange,
  newPhotos, removedPhotoIds, onAddPhotos, onRemoveExisting, onRemoveNew
}) => (
  <div className={WRAPPER_CLASS}>
    <IssueSummaryCard
      isEditing={isEditing}
      issue={issue}
      issueStatuses={issueStatuses}
      recipientOptions={recipientOptions}
      selectedUsers={selectedUsers}
      statusValue={statusValue}
      onEdit={onEdit}
      onStatusChange={onStatusChange}
      onUsersChange={onUsersChange}
    />
    <IssueFilesCard
      newPhotos={newPhotos}
      photos={issue.photos}
      removedPhotoIds={removedPhotoIds}
      onAddPhotos={onAddPhotos}
      onRemoveExisting={onRemoveExisting}
      onRemoveNew={onRemoveNew}
    />
    <IssueCommentCard value={commentValue} onChange={onCommentChange} />
  </div>
)

IssueSummaryTab.propTypes = {
  commentValue: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired,
  issue: PropTypes.shape({
    photos: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  issueStatuses: PropTypes.arrayOf(PropTypes.shape({})),
  newPhotos: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
  onAddPhotos: PropTypes.func.isRequired,
  onCommentChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemoveExisting: PropTypes.func.isRequired,
  onRemoveNew: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onUsersChange: PropTypes.func.isRequired,
  recipientOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  removedPhotoIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedUsers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  statusValue: PropTypes.number
}

IssueSummaryTab.defaultProps = {
  issueStatuses: [],
  statusValue: null
}

export default IssueSummaryTab
